/**
 * Social-account avatar. Renders the account image when present, otherwise a
 * neutral muted circle. Presentational only.
 */

type Props = {
    src?: string | null;
    alt?: string;
    className?: string;
};

const AccountAvatar = ({ src, alt = '', className = '' }: Props) => {
    const classes = `account-avatar ${className}`.trim();
    if (!src) {
        return <span className={`${classes} account-avatar--placeholder`} aria-hidden="true" />;
    }
    return <img className={classes} src={src} alt={alt} />;
};

export default AccountAvatar;
